module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/388.48be6b0c.png";